import { render, staticRenderFns } from "./consult.vue?vue&type=template&id=22c4f5b6&scoped=true"
import script from "./consult.vue?vue&type=script&lang=js"
export * from "./consult.vue?vue&type=script&lang=js"
import style0 from "./consult.vue?vue&type=style&index=0&id=22c4f5b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c4f5b6",
  null
  
)

export default component.exports